import React, { Component } from 'react';
import { connect } from 'react-redux';
import AvaRIEInput from '../fields/input/AvaRIEInput';
import  Collapsible from 'react-collapsible';
import AvaJsonTreeview from "../documentViewers/json/AvaJsonTreeview";
import deep from 'deep-diff';
import _ from 'underscore';
import $jp from '../../utils/jsonpath';

import LANGUAGES_CONTROLLER from '../../controllers/languages';
import ERROR_DOCUMENT_DETAIL_CONTROLLER from '../../controllers/errorDocumentDetail';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import JSON_TRANSFORM from '../../utils/jsonTransform/jsonTransformers';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';


const FORM_NAME = 'SAP_DOCUMENT_TYPE_RV_ERROR_DOCUMENT_EDITOR_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

class SAPDocumentTypeRVErrorDetailForm extends Component {

  constructor(props) {
    super(props);
    this.doReprocessErrorDocument = this.doReprocessErrorDocument.bind(this);
  }

  render() {
    log.debug('SAPDocumentTypeRVErrorDetailForm render(): ', this.props);

    if (!this.props.formData || !this.props.formData.fieldValues) {
      return (<div>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_NoFields')}</div>);
    }

    if(_.isEmpty(this.props.errorDetail))  {
      return (
        <h2 className="text-center"><br/><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_NoDetails')}</span></h2>
      );
    } 

    const fieldValues = (this.props.formData && this.props.formData.fieldValues) || {};    
    const jsonViewerValues = (this.props.formData && this.props.formData.structured) || {};
    const errorDetails = ( this.props.errorDetail) || {};
    const AdditionalDocumentRefTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AdditionalDocumentRef')}</span>;
    const BookingInformationTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_BookingInformation')}</span>;
    const FileDetailsTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_FileDetails')}</span>;
    const AllDataTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AllData')}</span>;

    let showBookingSection = true;
    let bookingInformation = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.BookingInformation');
    if(_.isEmpty(bookingInformation[0])) {
      showBookingSection = false
    };

    return (
      <div className="invoice-container">
        <h2>{fieldValues["errorMessage"]}</h2>
        <hr/>      
        
        {/*Header details */}
        <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceNumber')}:&nbsp;
          <AvaRIEInput
            propName="errorJson.ReportingDocument.InvoiceProperties.InvoiceNumber"
            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.InvoiceNumber"] || ""}
            change={this.handleRIEFieldChange.bind(this)}
            classEditing="editing width-auto"
          />
          <span className="float-right mt4">
              <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceDate')}:&nbsp;</span>
              <AvaRIEInput
                propName="errorJson.ReportingDocument.InvoiceProperties.InvoiceDate"
                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.InvoiceDate"] || ""}
                change={this.handleRIEFieldChange.bind(this)}
                classEditing="editing width-auto"
              />
              </span>
          <div className="clear"></div>
        </h2>
      
        {/*Supplier details */}
        <hr />            
        <s-row>
          <s-col span="6">
            <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Supplier')}</h2>
            {
              (() => {
                let inputHandler = this.handleRIEFieldChange.bind(this);
                let supplierData = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.SupplierData');
                if(!_.isArray(supplierData) || _.isEmpty(supplierData)) {
                  return (
                    <div></div>
                  );
                }
                supplierData = _.flatten(supplierData);
                return supplierData.map( (supplierObjField, index) => {
                  let keys = Object.keys(supplierObjField);
                  let singleValueFieldKeys = keys.filter( key => !_.isObject(supplierObjField[key]));
                  //Inner compoenent
                  let singleValueFieldComponents = singleValueFieldKeys.map( (fieldKey, j) => {
                    let fieldName = `errorJson.ReportingDocument.InvoiceProperties.SupplierData.${fieldKey}`;
                    let fieldLabel = `errorDocumentDetail_${fieldKey}`;
                    return (
                      <tr>
                        <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}:</span></td>
                        <td className="half-width">
                          <span>
                            <AvaRIEInput
                              propName={fieldName}
                              value={fieldValues[`${fieldName}`] || ''}
                              change={inputHandler}
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  });
                  let compositeValueFieldKeys = keys.filter(key => _.isObject(supplierObjField[key]) && !_.isArray(supplierObjField[key]) && key !== 'Identifier');
                  let compositeValueFieldComponents = compositeValueFieldKeys.map( (compositeValueFieldKey, j) => {
                    let valueObj = supplierObjField[compositeValueFieldKey];
                    if(_.isEmpty(valueObj)) {
                      return <tr></tr>
                    };
                    let valueObjKeys = Object.keys(valueObj);
                    return valueObjKeys.map( valueObjKey => {
                      let fieldName = `errorJson.ReportingDocument.InvoiceProperties.SupplierData.${compositeValueFieldKey}.${valueObjKey}`;
                      let fieldLabel = `errorDocumentDetail_${valueObjKey}`;
                      return (
                        <tr>
                          <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}:</span></td>
                          <td className="half-width">
                            <span>
                              <AvaRIEInput
                                propName={fieldName}
                                value={fieldValues[`${fieldName}`] || ''}
                                change={inputHandler}
                              />
                            </span>
                          </td>
                        </tr>
                      );
                    });
                  });

                  return (
                    <table key={index} className="borderless">
                      <tbody>
                        <tr>
                          <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierId')}:</span></td>
                          <td className="half-width">
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierID"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierID"]  || ""}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierInvoiceNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierInvoiceNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierInvoiceNumber"]  || ""}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        {singleValueFieldComponents}
                        {compositeValueFieldComponents}
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierIdentifierPassportNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.PassportNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.PassportNumber"]  || ""}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierIdentifierIdCardNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.IdCardNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.IdCardNumber"]  || ""}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierIdentifierResidencyCertificate')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.ResidencyCertificate"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.ResidencyCertificate"]  || ""}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })
              })()
            }
          </s-col>  
          <s-col span="6">
            <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Customer')}</h2>
            <table className="borderless">
              <tbody>
              <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerId')}</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerID"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerID"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr> 
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerName')}</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Name"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Name"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Address')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Address"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Address"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_City')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.City"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.City"] || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Country')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Country"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Country"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Email')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Telephone"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Email"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Telephone')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Telephone"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Telephone"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ZIP')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.ZIP"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.ZIP"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TaxNumber')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.TaxNumber"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.TaxNumber"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumber')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumber"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumber"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumberCountry')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumberCountry"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumberCountry"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerIdentifierPassportNumber')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.PassportNumber"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.PassportNumber"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerIdentifierIdCardNumber')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.IdCardNumber"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.IdCardNumber"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerIdentifierResidencyCertificate')}:</span></td>
                  <td>
                    <span>
                      <AvaRIEInput
                        propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.ResidencyCertificate"
                        value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.ResidencyCertificate"]  || ""}
                        change={this.handleRIEFieldChange.bind(this)}
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </s-col>    
        </s-row>

        {/*Document Data */}
        <div className="invoce-panel">
          <hr />
          <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentDetails')}</h2>
          <s-row>
            <s-col span="6">
              <table className="borderless">
                <tbody>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReporterID')}:</span></td>
                    <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.ReporterID"
                            value={fieldValues["errorJson.ReportingDocument.ReporterID"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentCurrency')}:</span></td>
                    <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.DocumentCurrency"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.DocumentCurrency"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                  </tr>
                  <tr>
                    <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentType')}:</span></td>
                    <td>
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.DocumentType"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.DocumentType"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TransactionDate')}:</span></td>
                    <td>
                      <span>
                       <AvaRIEInput
                          propName="errorJson.ReportingDocument.TransactionDate._"
                          value={fieldValues["errorJson.ReportingDocument.TransactionDate._"]}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CountryVATNumberUsedByCustomer')}: </span></td>
                    <td>
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedByCustomer"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedByCustomer"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CountryVATNumberUsedBySupplier')}: </span></td>
                    <td>
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedBySupplier"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedBySupplier"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>      
            </s-col>
            <s-col span="6">
              <table className="borderless">
                <tbody>
                  <tr>
                    <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ExchangeRateDate')}:</span></td>
                    <td>
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.ExchangeRateDate"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.ExchangeRateDate"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentIndicator')}:</span></td>
                    <td>
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.DocumentIndicator"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.DocumentIndicator"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TaxCurrency')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.TaxCurrency"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.TaxCurrency"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_LocalCurrency')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.LocalCurrency"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.LocalCurrency"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_LocalCurrency1')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.LocalCurrency1"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.LocalCurrency1"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DeliveryCondition')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.ExtraDocumentData.DeliveryCondition"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.ExtraDocumentData.DeliveryCondition"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceReceiptDate')}:</span></td>
                    <td className="half-width">
                      <span>
                        <AvaRIEInput
                          propName="errorJson.ReportingDocument.InvoiceProperties.InvoiceReceiptDate"
                          value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.InvoiceReceiptDate"]  || ""}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </s-col>
          </s-row>
        </div>

        {/* eInvoice Data Section */}
        <hr className="mt15 mb15" />
        <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_eInvoiceData') || 'EInvoice Data'}</h2>
        <table className="borderless">
          <tbody>
            <tr>
              <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_UniqueDocumentCode') || 'Unique Document Code'}:</span></td>
              <td className="half-width">
                <span>
                  <AvaRIEInput
                    propName="errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCode"
                    value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCode"] || ""}
                    change={this.handleRIEFieldChange.bind(this)}
                  />
                </span>
              </td>
            </tr>
            <tr>
              <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_UniqueDocumentCodeCountry') || 'Unique Document Code Country'}:</span></td>
              <td>
                <span>
                  <AvaRIEInput
                    propName="errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeCountry"
                    value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeCountry"] || ""}
                    change={this.handleRIEFieldChange.bind(this)}
                  />
                </span>
              </td>
            </tr>
            <tr>
              <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_UniqueDocumentCodeType') || 'Unique Document Code Type'}:</span></td>
              <td>
                <span>
                  <AvaRIEInput
                    propName="errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeType"
                    value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeType"] || ""}
                    change={this.handleRIEFieldChange.bind(this)}
                  />
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        {/*Invoice Lines */}
        <hr className="mt15 mb15" />
        <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines')}</h2>
        <s-row>                            
          <s-col span="6">
              {
                (() => {
                let inputHandler = this.handleRIEFieldChange.bind(this);
                let invoiceLines = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.InvoiceLines');
                if(!_.isArray(invoiceLines) || _.isEmpty(invoiceLines)) {
                  return (
                    <div></div>
                  );
                }
                invoiceLines = _.flatten(invoiceLines);
                return invoiceLines.map( (line, index) => {
                  let keys = Object.keys(line);
                  let singleValueFieldKeys = keys.filter( key => !_.isObject(line[key]));
                  //Inner compoenent
                  let singleValueFieldComponents = singleValueFieldKeys.map( (fieldKey, j) => {
                    let fieldName = `errorJson.ReportingDocument.InvoiceProperties.InvoiceLines[${index}].${fieldKey}`;
                    let fieldLabel = `errorDocumentDetail_${fieldKey}`;
                    return (
                      <tr>
                        <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}:</span></td>
                        <td className="half-width">
                          <span>
                            <AvaRIEInput
                              propName={fieldName}
                              value={fieldValues[`${fieldName}`] || ''}
                              change={inputHandler}
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  });

                  return (
                    <table key={index} className="borderless">
                      <tbody>
                        {singleValueFieldComponents}
                      </tbody>
                    </table>
                  );
                })
                })()
              }         
          </s-col>
          <s-col span="6">   
            {
                (() => {
                let inputHandler = this.handleRIEFieldChange.bind(this);
                let invoiceLines = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.InvoiceLines');
                if(!_.isArray(invoiceLines) || _.isEmpty(invoiceLines)) {
                  return (
                    <div></div>
                  );
                }
                invoiceLines = _.flatten(invoiceLines);
                return invoiceLines.map( (line, index) => {
                  let keys = Object.keys(line);
                  let lineEntryObjFieldKeys = keys.filter( key => _.isObject(line[key]) && !_.isArray(line[key]));
                  let objFieldComponents = lineEntryObjFieldKeys.map( (lineObjFieldKey) => {
                    let lineEntryObj = line[lineObjFieldKey];
                    if(_.isEmpty(lineEntryObj)) {
                      return <tr></tr>
                    };

                    //Get object keys 
                    let lineEntryObjKeys = Object.keys(lineEntryObj);
                    return lineEntryObjKeys.map( fieldKey => {
                      if(fieldKey === '$') {

                        let fieldObj = lineEntryObj[fieldKey];
                        if(_.isEmpty(fieldObj)) {
                          return <tr></tr>
                        };
                        let fieldObjKeys = Object.keys(fieldObj);

                        return fieldObjKeys.map( fkey => {

                          let fieldName = `errorJson.ReportingDocument.InvoiceProperties.InvoiceLines[${index}].${lineObjFieldKey}.${fieldKey}.${fkey}`; 
                          let fieldLabel = `errorDocumentDetail_${fkey}`;
                          return (
                              <tr>
                                <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}:</span></td>
                                <td className="half-width">
                                  <span>
                                    <AvaRIEInput
                                      propName={fieldName}
                                      value={fieldValues[`${fieldName}`] || ''}
                                      change={inputHandler}
                                    />
                                  </span>
                                </td>
                              </tr>
                            );
                        });
                      } else {
                        let fieldName = `errorJson.ReportingDocument.InvoiceProperties.InvoiceLines[${index}].${lineObjFieldKey}.${fieldKey}`; 
                        let fieldLabel = `errorDocumentDetail_${fieldKey}`;
                        return (
                            <tr>
                              <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}:</span></td>
                              <td className="half-width">
                                <span>
                                  <AvaRIEInput
                                    propName={fieldName}
                                    value={fieldValues[`${fieldName}`] || ''}
                                    change={inputHandler}
                                  />
                                </span>
                              </td>
                            </tr>
                          );
                      }
                      
                    });
                  });

                  return (
                    <table key={index} className="borderless">
                      <tbody>
                        {objFieldComponents}
                      </tbody>
                    </table>
                  );
                })
                })()
              }              
          </s-col>
        </s-row>

        {/* Document Totals */}
        <hr />
        <h2 className="mb15">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentTotals')}</h2>
        {
            (() => {
            let inputHandler = this.handleRIEFieldChange.bind(this);
            let currencies = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.InvoiceValues[*].Currency');
            let invoiceLines = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.InvoiceLines[*]');
            if(!_.isArray(invoiceLines) || _.isEmpty(invoiceLines)) {
              return (
                <div></div>
              );
            }
            //Build header component
            let headers = [
              'BaseAmount',
              'TaxAmount'
            ];
            let headerComponent = headers.map( header => {
              let fieldLabel = `errorDocumentDetail_${header}`;
              return (
                <th className="text-align-center">
                  {LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}
                </th>
              );
            });
            //Build body component 
            let amountFieldsData = invoiceLines.map ( (line, lineIndex ) => {
              return currencies.map ( (currency, currencyIndex) => {
                return {
                  currencyFieldName: `errorJson.ReportingDocument.InvoiceProperties.InvoiceValues[${currencyIndex}].Currency`,
                  taxAmountFieldName: `errorJson.ReportingDocument.InvoiceProperties.InvoiceLines[${lineIndex}].TaxAmount[${currencyIndex}]`,
                  baseAmountFieldName: `errorJson.ReportingDocument.InvoiceProperties.InvoiceLines[${lineIndex}].BaseAmount[${currencyIndex}]`,
                };
              });

            });
            let bodyComponent = amountFieldsData.map( (fieldData, fieldDataIndex) => {
              return fieldData.map ( (fieldDataEntry, fieldDataEntryIndex) => {
                return  (
                  <tr className={withFullStoryExclude()}>
                    <td className={withFullStoryExclude()}>
                      <span>
                        <AvaRIEInput
                          propName={fieldDataEntry.baseAmountFieldName}
                          value={fieldValues[`${fieldDataEntry.baseAmountFieldName}`] || ''}
                          change={inputHandler}
                        />
                      </span>
                      <span className="ml10">
                        <AvaRIEInput
                          propName={fieldDataEntry.currencyFieldName}
                          value={fieldValues[`${fieldDataEntry.currencyFieldName}`] || ''}
                          change={inputHandler}
                        />
                      </span>
                    </td>
                    <td className={withFullStoryExclude()}>
                    <span>
                        <AvaRIEInput
                          propName={fieldDataEntry.taxAmountFieldName}
                          value={fieldValues[`${fieldDataEntry.taxAmountFieldName}`] || ''}
                          change={inputHandler}
                        />
                      </span>
                      <span className="ml10">
                        <AvaRIEInput
                          propName={fieldDataEntry.currencyFieldName}
                          value={fieldValues[`${fieldDataEntry.currencyFieldName}`] || ''}
                          change={inputHandler}
                        />
                      </span>
                    </td>
                  </tr>
                );
              });
            });

          return (
            <table className="text-align-center">
              <thead>
                <tr>
                  {headerComponent}
                </tr>
              </thead>
              <tbody>
                {bodyComponent}
              </tbody>
            </table>
          );
        })()
      }  

      {/*Addditional Doc Reference*/}
    <hr />
    <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AdditionalDocData')}</h2>
    <Collapsible trigger={AdditionalDocumentRefTrigger}>
      <s-row>
        <s-col span="6">
          {
            (() => {
              let inputHandler = this.handleRIEFieldChange.bind(this);
              let additionalDocumentRef = $jp.query(errorDetails.errorJson, '$.ReportingDocument.InvoiceProperties.AdditionalDocumentReference');
              if(!_.isArray(additionalDocumentRef) || _.isEmpty(additionalDocumentRef)) {
                return (
                  <div></div>
                );
              }
              additionalDocumentRef = _.flatten(additionalDocumentRef);

              return (
                <table className="borderless">
                  <tbody>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AdditionalDocumentRef')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference._"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference._"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentAccountInformation')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentAccountInformation"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentAccountInformation"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentAmount')}:</span></td>
                      <td className={withFullStoryExclude("half-width")}>
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentAmount"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentAmount"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentCurrency')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentCurrency"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$ClearingDocumentCurrency"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentDate')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentDate"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentDate"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentNumber')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentNumber"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentNumber"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentPayementMethod')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentPayementMethod"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentPayementMethod"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReferenceDocument')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.DocHeadText"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.DocHeadText"]  || ""} 
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReferenceDocument')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ReferenceDocument"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ReferenceDocument"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReferenceType')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ReferenceType"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ReferenceType"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SAPDocumentType')}:</span></td>
                      <td className="half-width">
                        <span>
                          <AvaRIEInput
                            propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.SAPDocumentType"
                            value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.SAPDocumentType"]  || ""}
                            change={this.handleRIEFieldChange.bind(this)}
                          />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              );
            })()
          }  
        </s-col>
      </s-row>
    </Collapsible>

        {
          (() => {
            if (showBookingSection) {
              return(
                <div>{/*Booking Information*/}
                  <Collapsible trigger={BookingInformationTrigger}>
                    <s-row>
                      <s-col span="6">
                        {
                          (() => {
                            let inputHandler = this.handleRIEFieldChange.bind(this);
                            bookingInformation = _.flatten(bookingInformation);
                            let headers = Object.keys(bookingInformation[0]);
                            let headerComponent = headers.map( header => {
                              let fieldLabel = `errorDocumentDetail_${header}`;
                              return (
                                <th>
                                  {LANGUAGES_CONTROLLER.format(this.props.languages, fieldLabel)}
                                </th>
                              );
                            });

                            let bodyComponent = bookingInformation.map( (line, rowIndex) => {
                              let colKeys = Object.keys(line);
                              let columnComponent =  colKeys.map( (fieldKey) => {
                                let fieldName = `errorJson.ReportingDocument.InvoiceProperties.BookingInformation[${rowIndex}].${fieldKey}`;
                                return (
                                  <td>
                            <span>
                              <AvaRIEInput
                                propName={fieldName}
                                value={fieldValues[`${fieldName}`] || ''}
                                change={inputHandler}
                              />
                            </span>
                                  </td>
                                );
                              });

                              return (
                                <tr>
                                  {columnComponent}
                                </tr>
                              );
                            });
                            return (
                              <table className="borderless">
                                <thead>
                                {headerComponent}
                                </thead>
                                <tbody>
                                {bodyComponent}
                                </tbody>
                              </table>
                            );
                          })()
                        }
                      </s-col>
                    </s-row>
                  </Collapsible>
                </div>
              )
            }
          })()
        }
        {/* Document Details View */}
        {/* JSON Viewer for _full_ document */}
        <Collapsible trigger={FileDetailsTrigger}>
          <table className="borderless">
            <tbody>
              <tr>
                <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ErrorUUID')}</span></td>
                <td>{fieldValues["errorJson.ReportingDocument.IVATUUID"]}</td>
              </tr>
            </tbody>
          </table>
        </Collapsible>
        {/* Document Details View */}

        {/* JSON Viewer for _full_ document */}
        <Collapsible trigger={AllDataTrigger}>
          <AvaJsonTreeview
            src={((jsonViewerValues && jsonViewerValues.errorJson && jsonViewerValues.errorJson.ReportingDocument) || {})}
            collapsed={true}
            onEdit={
              e => { this.handleJsonViewerChange(e) }
            }
          />
        </Collapsible>
        {
          this.props.formData.changed ? (
            <div>
            <button className="primary mt15" onClick={this.onSubmitForm.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Submit')}</button>
            <button className="secondary mt15" onClick={this.onResetForm.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Reset')}</button>
            </div>
          ) : (<div></div>)
        }
      </div>  
    );
  }

  componentWillUnmount() {
    log.debug('componentWillUnMount: ', FORM_NAME);
    this.props.doDestroyForm(FORM_NAME);
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.doInitialiseForm(this.props.errorDetail);
    this.props.doAddStructuredObject(this.props.errorDetail);
  }

  handleRIEFieldChange(data){
    for (const [key, value] of Object.entries(data)) {
      log.debug('handleRIEFieldChange :', key, value);
      this.doFieldChange(key,value);
    }
  }

  handleJsonViewerChange(data){
    log.debug('handleJsonViewerChange: ', data);

    const diff = deep(data.existing_src, data.updated_src);
    let value = diff[0].rhs;
    let key = 'errorJson.ReportingDocument.';
    key += JSON_TRANSFORM.arrayToFlatReference(diff[0].path);

    // SVR-840 Make values not editable in treeview to match main ux
    // the change is reset back to the old value 'lhs' before doing the update
    // list can be extended if needed
    if(_.contains(['IVATUUID','ConnectorVersion', 'ConnectorName'],data.name)){
      value = diff[0].lhs;
    }

    this.doFieldChange(key,value);
  }

  doFieldChange(key, value){
    log.debug('doFieldChange: key: %s value: ', key, value);
    this.props.onFieldChange(key, value);
    this.props.onStructuredFieldChange(key, value);
  }

  doReprocessErrorDocument(formData, callback){
    log.debug('doReprocessError Page: formData: ', formData);
    this.props.doReprocessError(formData, callback);
  }

  onSubmitForm() {
    log.debug('onSubmitForm(): ', this.props.formData);
    this.doReprocessErrorDocument(this.props.formData, this.props.onProcessed);
    if(typeof this.props.submitHandler === 'function') {
      this.props.submitHandler(this.props.formData);
    }
    this.props.doFormSubmitted(FORM_NAME);
  }

  onResetForm() {
   log.debug('onResetForm(): ');
   this.props.doResetForm(FORM_NAME);
   this.props.doAddStructuredObject(this.props.errorDetail);
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),

    // TODO: Add additional data we want to extract from the global state and inject into the props here
  };
}


SAPDocumentTypeRVErrorDetailForm.defaultProps = {
  onProcessed: ()=>{}
}

function mapDispatchersToProps(dispatch) {
  return {
    // Standard form actions
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, JSON_TRANSFORM.flattenJSON(initialValues)));
    },
    doAddStructuredObject: (structured) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doAddStructuredObject(FORM_NAME, structured ));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    onStructuredFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doStructuredFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    },
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
    doReprocessError: (formData, callback=()=>{}) => {
      dispatch(ERROR_DOCUMENT_DETAIL_CONTROLLER.doReprocessError(formData, callback));
    }
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(SAPDocumentTypeRVErrorDetailForm);
